"use strict";

exports.__esModule = true;
/* eslint-disable no-underscore-dangle */
var resolveModuleDefault = function resolveModuleDefault(module) {
  return module.__esModule ? module.default : module;
};

exports.default = resolveModuleDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/loadable-components/utils/resolveModuleDefault.js
// module id = 81
// module chunks = 3